import Typography from "@mui/material/Typography";
import type { SearchTemplateValue, TodoAssignmentCounts } from "../../api";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { TodoRoleChips } from "./TodoRoleChips";
import { TODO_HINTS } from "./todo-hints";
import { setClassNamesByCount } from "./utils";

/**
 * Quiet conversations waiting to be poked or taken off, ticked off exactly
 * like the pitch-response item: the same saved search, the same step-through,
 * and Mark as Done removing the tag behind it.
 */
export const StaleConversationsTodoItem = ({
	staleConversations,
	counts,
	readOnly = false,
}: {
	staleConversations: SearchTemplateValue;
	counts: TodoAssignmentCounts;
	readOnly?: boolean;
}) => (
	<BaseTodoBox
		dataComponent="todo-stale-conversations"
		className={setClassNamesByCount(staleConversations.count)}
		title={
			<AttentionBadge
				count={staleConversations.count}
				title="Stale conversations"
				readOnly={readOnly}
				url={staleConversations.url}
			/>
		}
		description={
			<Typography variant="body1" component="div" color="textPrimary">
				Poke or mark as done
			</Typography>
		}
		to={staleConversations.url}
		readOnly={readOnly}
		hint={TODO_HINTS.staleConversations}
		subRow={
			<TodoRoleChips
				counts={counts}
				kind="stale"
				baseUrl={staleConversations.url}
			/>
		}
	/>
);
